<template>
  <div>
    <a-radio-group 
			name="radioGroup" default-value="USD"
			v-model="model.value"
		>
      <a-radio value="USD">
        USD
      </a-radio>
      <a-radio value="KHR">
        KHR
      </a-radio>
      <a-radio value="THB">
        THB
      </a-radio>
    </a-radio-group>
  </div>
</template>

<script>
export default {
  props: ['value'],
	data() {
		return {
			model: {}
		}
	},
	created() {
		this.model = this.value
	},

}
</script>
